import {Editor} from '@tiptap/core';
import Image from '@tiptap/extension-image';
import StarterKit from '@tiptap/starter-kit';
import BubbleMenu from '@tiptap/extension-bubble-menu';
import Italic from '@tiptap/extension-italic';
import Underline from '@tiptap/extension-underline';
import Bold from '@tiptap/extension-bold';
import BulletList from '@tiptap/extension-bullet-list';
import Placeholder from '@tiptap/extension-placeholder';

import Document from '@tiptap/extension-document';
import ListItem from '@tiptap/extension-list-item';
import HardBreak from '@tiptap/extension-hard-break';
import Heading from '@tiptap/extension-heading';
import Text from '@tiptap/extension-text';
import Link from '@tiptap/extension-link';
import ImageResize from 'tiptap-extension-resize-image';
import {saveAs} from 'file-saver';
import {Slice, DOMParser, DOMSerializer} from 'prosemirror-model';
import {Node} from '@tiptap/core';
import {debounce} from 'lodash';


const BlockWithLabel = Node.create({
    name: 'blockWithLabel',

    group: 'block',

    content: 'block+',

    addNodeView() {
        return ({node, view, getPos}) => {
            const dom = document.createElement('div');
            const label = document.createElement('span');

            // Imposta il nome del nodo (p, h1, h2, etc.)
            label.textContent = node.type.name;
            label.style.cssText = 'position: absolute; left: -40px; font-size: 12px; color: gray;';

            dom.style.position = 'relative';
            dom.appendChild(label);

            // Contenitore del nodo effettivo
            const contentDOM = document.createElement('div');
            contentDOM.style.marginLeft = '40px'; // Sposta il contenuto per far spazio all'etichetta
            dom.appendChild(contentDOM);

            return {
                dom,
                contentDOM,
            };
        };
    },
});


function ControllerApp(__env, UserService, $element, $translate, $timeout, $scope, $stateParams, $sce, $window, article, $mdDialog, DocxService, WriterAssistantService) {
    var vm = $scope;
    vm.articleDataSet = article;

// Debounce the updateArticle call

    vm.subscriptionCheckLoading = true;
    vm.canDoTrial = false;
    vm.trialPeriodDays = __env.trialPeriodDays;
    vm.hasValidSuscription = true;

    async function checkSubscription() {
        const response = await UserService.limits();
        try {
            vm.hasValidSuscription = response.data.limits.find(function (service) {
                return service.alias === 'seo-editor';
            }).qtyAllowed > 0;
            vm.canDoTrial = response.data.canDoTrial;
        } catch (e) {
            vm.hasValidSuscription = false;
        }

        $timeout(() => {
            vm.subscriptionCheckLoading = false;
        }, 1000);

        // Set initial editable state based on subscription
        vm.editor.setEditable(vm.hasValidSuscription);
    }

    checkSubscription();

    $scope.savingInLoading = false;
    const debouncedUpdateArticle = debounce(async (articleId, articleData) => {
        $scope.savingInLoading = true;
        try {
            await WriterAssistantService.updateArticle(articleId, articleData);
            vm.articleDataSet.updatedAt = new Date();
        } catch (error) {
            $window.console.warn('Unable to autosave the SEO article.', error);
        } finally {
            $scope.savingInLoading = false;
            $scope.$applyAsync();
        }
    }, 1000);

    vm.openWordPressPublish = function (event) {
        if (!vm.articleDataSet || !vm.articleDataSet.id || !vm.hasValidSuscription) {
            return;
        }

        // The dialog flushes the current editor state before calling WordPress.
        debouncedUpdateArticle.cancel();
        $mdDialog.show({
            controller: 'WriterAssistantWordPressPublishCtrl',
            templateUrl: 'app/modules/writerassistant/editor/dialog/wordpress-publish/wordpress-publish.html',
            targetEvent: event,
            clickOutsideToClose: false,
            escapeToClose: false,
            locals: {
                article: vm.articleDataSet,
            },
        });
    };

    if (!vm.articleDataSet ||
        !vm.articleDataSet.content ||
        !vm.articleDataSet.content.html) {
        vm.articleDataSet.content = {
            html: '',
            json: {}
        };
    }

    vm.aiLoading = false;

    function sendPromptToAI(action) {
        if (!vm.hasValidSuscription) {
            return;
        }
        if (vm.aiLoading) {
            return;
        }
        vm.aiLoading = true;
        const {state, view} = vm.editor;
        const {selection} = state;
        if (selection.empty) {
            vm.aiLoading = false;
            console.warn("No text selected");
            return;
        }

        // Get the selected content as HTML
        const slice = state.doc.slice(selection.from, selection.to);
        const fragment = slice.content;

        // Use DOMSerializer to serialize the ProseMirror document fragment to HTML
        const domSerializer = DOMSerializer.fromSchema(vm.editor.schema);

        const div = document.createElement('div');
        div.appendChild(domSerializer.serializeFragment(fragment));
        const selectedHTML = div.innerHTML;

        // Call rewriteTextWithAI to process the selected HTML content
        WriterAssistantService.rewriteTextWithAI($stateParams.id, action, selectedHTML)
            .then(function (aiResponse) {
                if (aiResponse && aiResponse.trim()) {
                    // Clean AI response
                    const cleanAiResponse = aiResponse.replace(/(\r\n|\n|\r)/gm, "").trim();

                    // Parse the AI's cleaned HTML response into a ProseMirror Node
                    const domParser = DOMParser.fromSchema(vm.editor.schema);
                    const dom = document.createElement('div');
                    dom.innerHTML = cleanAiResponse;

                    // Parse the HTML into a document slice, including handling of marks (e.g., <em>)
                    const parsedSlice = domParser.parseSlice(dom, {
                        preserveWhitespace: true, // Preserve whitespace to avoid accidental removal of marks
                    });

                    // Ensure open depths are consistent
                    const fromResolved = state.doc.resolve(selection.from);
                    const toResolved = state.doc.resolve(selection.to);

                    const adjustedSlice = new Slice(
                        parsedSlice.content,
                        Math.min(parsedSlice.openStart, fromResolved.depth),
                        Math.min(parsedSlice.openEnd, toResolved.depth)
                    );

                    // Replace the range with the adjusted slice
                    const transaction = state.tr.replaceRange(
                        selection.from,
                        selection.to,
                        adjustedSlice
                    );

                    vm.aiLoading = false;
                    // Apply the transaction
                    view.dispatch(transaction);
                } else {
                    console.warn("AI returned an empty or invalid response.");
                }
                $scope.$apply();
                vm.aiLoading = false;
            }).catch(function (error) {
            vm.aiLoading = false;
            console.error("Error from AI service:", error);
        });
    }


    // Function to expand the selected content
    vm.expandContent = function () {
        sendPromptToAI("Expand");
    };

    // Function to simplify the selected content
    vm.simplifyContent = function () {
        sendPromptToAI("Simplify");
    };

    // Function to rewrite the selected content
    vm.rewriteContent = function () {
        sendPromptToAI("Rewrite");
    };

    // Function to summarize the selected content
    vm.summarizeContent = function () {
        sendPromptToAI("Summarize");
    };

// Function to remove empty tags recursively
    function removeEmptyTags(element) {
        const children = Array.from(element.childNodes);

        children.forEach(child => {
            if (child.nodeType === Node.ELEMENT_NODE) {
                removeEmptyTags(child); // Recursively clean child elements
            }

            // Remove the element if it's empty and not an img (or other self-closing non-text tags)
            if (child.nodeType === Node.ELEMENT_NODE && child.nodeName.toLowerCase() !== 'img' && !child.innerHTML.trim()) {
                child.remove();
            }
        });
    }

// Function to trim the selected content and remove empty tags
    vm.trimContent = function () {
        if (vm.aiLoading) {
            return;
        }
        vm.aiLoading = true;
        $timeout(() => {
            try {
                const {state, view} = vm.editor;
                const {selection} = state;

                if (selection.empty) {
                    vm.aiLoading = false;
                    console.warn("No text selected");
                    return;
                }

                // Get the selected content as HTML
                const slice = state.doc.slice(selection.from, selection.to);
                const fragment = slice.content;

                // Use DOMSerializer to serialize the ProseMirror document fragment to HTML
                const domSerializer = DOMSerializer.fromSchema(vm.editor.schema);
                const div = document.createElement('div');
                div.appendChild(domSerializer.serializeFragment(fragment));
                let selectedHTML = div.innerHTML;

                selectedHTML = selectedHTML
                    .replace(/(\r\n|\n|\\n|\r|\\r|\\t|\t)/gm, "")
                    .replace(/\s+/g, ' ')
                    .trim();

                // Parse the HTML into a DOM element and remove empty tags
                div.innerHTML = selectedHTML;
                removeEmptyTags(div);  // Clean up empty tags recursively

                selectedHTML = div.innerHTML;

                // Parse the cleaned HTML back into a ProseMirror document slice
                const domParser = DOMParser.fromSchema(vm.editor.schema);
                const dom = document.createElement('div');
                dom.innerHTML = selectedHTML;

                // Parse the HTML into a document slice, including handling of marks (e.g., <em>)
                const parsedSlice = domParser.parseSlice(dom, {
                    preserveWhitespace: true, // Preserve whitespace to avoid accidental removal of marks
                });

                // Ensure open depths are consistent
                const fromResolved = state.doc.resolve(selection.from);
                const toResolved = state.doc.resolve(selection.to);

                const adjustedSlice = new Slice(
                    parsedSlice.content,
                    Math.min(parsedSlice.openStart, fromResolved.depth),
                    Math.min(parsedSlice.openEnd, toResolved.depth)
                );

                // Replace the range with the adjusted slice
                const transaction = state.tr.replaceRange(
                    selection.from,
                    selection.to,
                    adjustedSlice
                );

                vm.aiLoading = false;
                // Apply the transaction
                view.dispatch(transaction);
            } catch (e) {
                console.log(e);
            }
            vm.aiLoading = false;
        }, 2000);
    };


    var headings = [
        {name: 'Normal text', command: 'setParagraph'},
        {name: 'Heading 1', command: 'toggleHeading', argument: {level: 1}},
        {name: 'Heading 2', command: 'toggleHeading', argument: {level: 2}},
        {name: 'Heading 3', command: 'toggleHeading', argument: {level: 3}},
        {name: 'Heading 4', command: 'toggleHeading', argument: {level: 4}},
        {name: 'Heading 5', command: 'toggleHeading', argument: {level: 5}},
        {name: 'Heading 6', command: 'toggleHeading', argument: {level: 6}},
    ];

    vm.selectedHeading = {
        value: 'Normal text',
    };

    vm.applyHeading = function () {
        headings.forEach(button => {
            if (button.name === vm.selectedHeading.value) {
                vm.executeCommand(button);
            }
        });
    };

    vm.editorToolbar = [
        {
            type: 'select',
            model: vm.selectedHeading,
            values: headings,
            runCallback: vm.applyHeading
        },
        {
            name: 'bold',
            command: 'toggleBold',
            icon: $sce.trustAsHtml(
                '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 12h9a4 4 0 0 1 0 8H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h7a4 4 0 0 1 0 8"/></path></svg>'
            ),
        },
        {
            name: 'italic',
            command: 'toggleItalic',
            icon: $sce.trustAsHtml(
                '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="19" x2="10" y1="4" y2="4"/><line x1="14" x2="5" y1="20" y2="20"/><line x1="15" x2="9" y1="4" y2="20"/></path></svg>'
            ),
        },
        {
            name: 'underline',
            command: 'toggleUnderline',
            icon: $sce.trustAsHtml(
                '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 4v6a6 6 0 0 0 12 0V4"/><line x1="4" x2="20" y1="20" y2="20"/></path></svg>'
            ),
        },
        {
            inline: false,
            name: 'strike',
            command: 'toggleStrike',
            icon: $sce.trustAsHtml(
                '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 4H9a3 3 0 0 0-2.83 4"/><path d="M14 12a4 4 0 0 1 0 8H6"/><line x1="4" x2="20" y1="12" y2="12"/></path></svg>'
            ),
        },
        {
            inline: false,
            name: 'image',
            command: 'insertImage',
            icon: $sce.trustAsHtml(
                '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="18" height="18" x="3" y="3" rx="2" ry="2"/><circle cx="9" cy="9" r="2"/><path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"/></path></svg>'
            ),
        },
        {
            inline: false,
            name: 'link',
            command: 'setLink',
            icon: $sce.trustAsHtml(
                '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></path></svg>'
            ),
        },
        {
            inline: false,
            name: 'clear marks',
            command: 'unsetAllMarks',
            icon: $sce.trustAsHtml(
                '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7V4h16v3"/><path d="M5 20h6"/><path d="M13 4 8 20"/><path d="m15 15 5 5"/><path d="m20 15-5 5"/></path></svg>'
            ),
        },
        {
            name: 'bullet list',
            command: 'toggleBulletList',
            icon: $sce.trustAsHtml(
                '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="8" x2="21" y1="6" y2="6"/><line x1="8" x2="21" y1="12" y2="12"/><line x1="8" x2="21" y1="18" y2="18"/><line x1="3" x2="3.01" y1="6" y2="6"/><line x1="3" x2="3.01" y1="12" y2="12"/><line x1="3" x2="3.01" y1="18" y2="18"/></path></svg>'
            ),
        },
        {
            name: 'ordered list',
            command: 'toggleOrderedList',
            icon: $sce.trustAsHtml(
                '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="10" x2="21" y1="6" y2="6"/><line x1="10" x2="21" y1="12" y2="12"/><line x1="10" x2="21" y1="18" y2="18"/><path d="M4 6h1v4"/><path d="M4 10h2"/><path d="M6 18H4c0-1 2-2 2-3s-1-1.5-2-1"/></path></svg>'
            ),
        },
        {
            inline: false,
            name: 'code block',
            command: 'toggleCodeBlock',
            icon: $sce.trustAsHtml(
                '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m10 9-2 3 2 3"/><path d="m14 15 2-3-2-3"/><rect width="18" height="18" x="3" y="3" rx="2"/></path></svg>'
            ),
        },
        {
            inline: false,
            name: 'blockquote',
            command: 'toggleBlockquote',
            icon: $sce.trustAsHtml(
                '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h1a1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z"/><path d="M5 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h1a1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z"/></path></svg>'
            ),
        },
        {
            name: 'undo',
            command: 'undo',
            disable: true,
            icon: $sce.trustAsHtml(
                '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 14 4 9l5-5"/><path d="M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5a5.5 5.5 0 0 1-5.5 5.5H11"/></path></svg>'
            ),
        },
        {
            name: 'redo',
            command: 'redo',
            disable: true,
            icon: $sce.trustAsHtml(
                '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m15 14 5-5-5-5"/><path d="M20 9H9.5A5.5 5.5 0 0 0 4 14.5A5.5 5.5 0 0 0 9.5 20H13"/></path></svg>'
            ),
        },
    ];


// Funzione per generare il documento DOCX e scaricarlo
    async function exportToDocx() {
        const blob = await DocxService.getDocxFromTipTapJson(
            vm.editor.getJSON()
        );
        // Avvia il download del file
        saveAs(blob, vm.articleDataSet.mainKeyword + ".docx");
    }

    vm.exportDoc = exportToDocx;
    vm.editorToolbarBubble = [
        {
            name: 'bold',
            command: 'toggleBold',
            icon: $sce.trustAsHtml(
                '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 12h9a4 4 0 0 1 0 8H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h7a4 4 0 0 1 0 8"/></path></svg>'
            ),
        },
        {
            name: 'italic',
            command: 'toggleItalic',
            icon: $sce.trustAsHtml(
                '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="19" x2="10" y1="4" y2="4"/><line x1="14" x2="5" y1="20" y2="20"/><line x1="15" x2="9" y1="4" y2="20"/></path></svg>'
            ),
        },
        {
            name: 'undo',
            command: 'undo',
            disable: true,
            icon: $sce.trustAsHtml(
                '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 14 4 9l5-5"/><path d="M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5a5.5 5.5 0 0 1-5.5 5.5H11"/></path></svg>'
            ),
        },
        {
            name: 'redo',
            command: 'redo',
            disable: true,
            icon: $sce.trustAsHtml(
                '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m15 14 5-5-5-5"/><path d="M20 9H9.5A5.5 5.5 0 0 0 4 14.5A5.5 5.5 0 0 0 9.5 20H13"/></path></svg>'
            ),
        }
    ];

    /* Toolbar labels differ from the tiptap node/mark names: map the toggles. */
    const ACTIVE_FORMAT_NAMES = {
        'bullet list': 'bulletList',
        'ordered list': 'orderedList',
        'code block': 'codeBlock'
    };

    vm.isActive = (format) => {
        if (!vm.editor || !format) return false;
        return vm.editor.isActive(ACTIVE_FORMAT_NAMES[format] || format);
    };

    vm.executeCommand = (button) => {
        if (!vm.editor) {
            return;
        }

        if (button.command === 'insertImage') {
            vm.insertImage();
            return;
        }
        if (button.command === 'setLink') {
            setLink();
            return;
        }

        if (button.argument) {
            vm.editor.chain().focus()[button.command](button.argument).run();
        } else {
            vm.editor.chain().focus()[button.command]().run();
        }

        updateUndoRedoState(); // Update the state after executing the command
    };


    vm.insertImage = () => {
        const src = prompt('Enter the image URL');
        const alt = prompt('Enter the alt text for the image');
        if (src) {
            vm.editor.chain().focus().setImage({src, alt}).run();
        }
    };

    vm.openAltTextEditor = () => {
        const {view} = vm.editor;
        const {state} = view;

        const {selection} = state;
        let altText = '';
        let previewImageSrc = '';

        // Aggiungi un controllo esplicito per la posizione iniziale
        const node = state.doc.nodeAt(selection.from);
        if (node && node.type.name === 'image') {
            altText = node.attrs.alt || '';
            previewImageSrc = node.attrs.src || '';
        } else if (selection.from === 0 && state.doc.firstChild.type.name === 'image') {
            // Caso in cui l'immagine è la primissima cosa nel documento
            altText = state.doc.firstChild.attrs.alt || '';
            previewImageSrc = state.doc.firstChild.attrs.src || '';
        }

        vm.previewImageSrc = previewImageSrc;
        vm.altText = altText; // Set the ng-model to the retrieved alt text
    };

    vm.updateImageAlt = (altText) => {
        const {view} = vm.editor;
        const {state, dispatch} = view;
        const {schema} = state;

        const {selection} = state;
        let tr = state.tr;

        state.doc.descendants((node, pos) => {
            if (node.type.name === 'image' && pos <= selection.from && pos + node.nodeSize >= selection.to) {
                tr = tr.setNodeMarkup(pos, schema.nodes.image, {
                    ...node.attrs,
                    alt: altText
                });
                return false; // Stop iterating once we find the image node
            }
        });

        if (tr !== state.tr) {
            dispatch(tr);
        }

        vm.editor.chain().focus().run();
    }

    $scope.showAlert = (ev) => {
        $mdDialog.show(
            $mdDialog.alert()
                .parent(angular.element(document.querySelector('#popupContainer')))
                .clickOutsideToClose(true)
                .title('This is an alert title')
                .textContent('You can specify some description text in here.')
                .ariaLabel('Alert Dialog Demo')
                .ok('Got it!')
                .targetEvent(ev)
        );
    };

    vm.updateImageSrc = (src) => {
        const {view} = vm.editor;
        const {state, dispatch} = view;
        const {schema} = state;

        const {selection} = state;
        let tr = state.tr;

        state.doc.descendants((node, pos) => {
            if (node.type.name === 'image' && pos <= selection.from && pos + node.nodeSize >= selection.to) {
                tr = tr.setNodeMarkup(pos, schema.nodes.image, {
                    ...node.attrs,
                    src: src
                });
                return false; // Stop iterating once we find the image node
            }
        });

        if (tr !== state.tr) {
            dispatch(tr);
        } else {
            console.log("No changes made, not dispatching");
        }

        vm.editor.chain().focus().run();
    };


    function initEditor() {
        const content = vm.articleDataSet.content.html;
        vm.editor = new Editor({
            element: document.getElementById('editor-wrapper-element'),
            extensions: [
                StarterKit,
                BlockWithLabel, // Aggiungi la custom NodeView per mostrare il tipo di nodo
                Image,
                ImageResize,
                Italic,
                Bold,
                Underline,
                BulletList,
                Placeholder.configure({
                    // Use a placeholder:
                    placeholder: $translate.instant('Write something …'),
                    // Use different placeholders depending on the node type:
                    // placeholder: ({ node }) => {
                    //   if (node.type.name === 'heading') {
                    //     return 'What’s the title?'
                    //   }

                    //   return 'Can you add some further context?'
                    // },
                }),
                Document,
                ListItem,
                HardBreak,
                Heading,
                Link.configure({
                    openOnClick: false,
                    autolink: true,
                    defaultProtocol: 'https',
                }),
                Text,
                BubbleMenu.configure({
                    pluginKey: 'bubbleMenuText',
                    element: document.querySelector('#menu-editor-bubble-format-text'),
                    shouldShow: ({editor}) => !editor.isActive('image'),
                }),
                BubbleMenu.configure({
                    pluginKey: 'bubbleMenuImage',
                    element: document.querySelector('#menu-editor-bubble-image'),
                    shouldShow: ({editor}) => editor.isActive('image'),
                    tippyOptions: {
                        placement: 'top', // Place the bubble menu above the image
                        offset: [0, 10], // Adjust the offset to fine-tune the position
                        // Additional options can be added here
                    },
                }),
            ],
            content,
            onUpdate: ({editor}) => {
                vm.articleDataSet.content.html = editor.getHTML();
                vm.articleDataSet.content.json = editor.getJSON();
                vm.articleDataSet.content.text = editor.getText();
                // Update undo/redo state when the editor content updates
                updateUndoRedoState();

                debouncedUpdateArticle(vm.articleDataSet.id, vm.articleDataSet);
            },
        });

        // Update undo/redo state when the editor content updates
        updateUndoRedoState();
        // Keep the toolbar in sync while typing or selecting: tiptap events run
        // outside Angular, so force a digest for the is-active highlight.
        vm.editor.on('transaction', () => { updateUndoRedoState(); });
        vm.editor.on('selectionUpdate', () => { $scope.$applyAsync(); });
        vm.articleDataSet.content.html = vm.editor.getHTML();
        vm.articleDataSet.content.json = vm.editor.getJSON();
        vm.articleDataSet.content.text = vm.editor.getText();
        vm.editor.on('selectionUpdate', evt => {
            const {state} = vm.editor.view;
            const {selection} = state;
            var match = state.doc.resolve(state.selection.anchor).parent;
            if (!match.attrs.level) {
                vm.selectedHeading.value = 'Normal text';
            } else {
                vm.selectedHeading.value = 'Heading ' + match.attrs.level;
            }

            // Check if the selection is an image
            const node = state.doc.nodeAt(selection.from);
            if (node && node.type.name === 'image') {
                vm.openAltTextEditor(); // Populate the alt text input
            }
        });

        // Manualmente forzare un aggiornamento della selezione
        const {view} = vm.editor;
        if (view.state.selection.from === 0 && view.state.doc.firstChild.type.name === 'image') {
            // Se la selezione è all'inizio e il primo nodo è un'immagine
            vm.openAltTextEditor();
        }

        vm.editor.on('init', () => {
            const {state} = vm.editor.view;
            const {selection} = state;

            // Check if the initial selection is an image
            const node = state.doc.nodeAt(selection.from);
            if (node && node.type.name === 'image') {
                vm.openAltTextEditor(); // Populate the alt text input
            }
        });
    }

    $scope.$on('$destroy', function () {
        if (vm.editor) {
            vm.editor.destroy();
        }
    });

    const setLink = () => {
        const previousUrl = vm.editor.getAttributes('link').href;
        const url = window.prompt('Provide the final destination URL of your link', previousUrl);

        // cancelled
        if (url === null) {
            return;
        }

        // empty
        if (url === '') {
            vm.editor.chain().focus().extendMarkRange('link').unsetLink()
                .run();

            return;
        }

        // update link
        vm.editor
            .chain()
            .focus()
            .extendMarkRange('link')
            .setLink({href: url})
            .run();
    };


// Function to check if undo/redo is available and update the button states
    function updateUndoRedoState() {
        if (vm.editor) {
            const canUndo = vm.editor.can().undo();
            const canRedo = vm.editor.can().redo();

            // Update the toolbar buttons' disable state
            vm.editorToolbar.forEach(button => {
                if (button.command === 'undo') {
                    button.disable = !canUndo;
                } else if (button.command === 'redo') {
                    button.disable = !canRedo;
                }
            });

            // If you're using Bubble Menu for undo/redo:
            vm.editorToolbarBubble.forEach(button => {
                if (button.command === 'undo') {
                    button.disable = !canUndo;
                } else if (button.command === 'redo') {
                    button.disable = !canRedo;
                }
            });

            $scope.$applyAsync();  // Apply changes to the scope
        }
    }


    $timeout(() => {
        initEditor();

// Listen for selection changes to trigger the alt text editor
        vm.editor.on('selectionUpdate', () => {
            const {state} = vm.editor.view;
            const {selection} = state;

            // Check if the selection is an image
            const node = state.doc.nodeAt(selection.from);
            if (node && node.type.name === 'image') {
                vm.openAltTextEditor(); // Populate the alt text input
            }
        });
    }, 50);
}

ControllerApp.$inject = ['__env', 'UserService', '$element', '$translate', '$timeout', '$scope', '$stateParams', '$sce', '$window', 'article', '$mdDialog', 'DocxService', 'WriterAssistantService'];

export default ControllerApp;
